import { render } from "./MultipleChoiceGalery.vue?vue&type=template&id=31532759"
import script from "./MultipleChoiceGalery.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceGalery.vue?vue&type=script&lang=js"

import "./MultipleChoiceGalery.vue?vue&type=style&index=0&id=31532759&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__